<div class="flex flex-col gap-4">
  @if (formInitialized()) {
    <app-campaign-dates [form]="form" [campaignStatus]="campaign()?.status" />
    <app-campaign-finance [form]="form" />

    @if (showCustomerField()) {
      <app-campaign-customer [form]="form" />
    }

    @if (showTeamSelectField()) {
      <app-campaign-team-select [form]="form" />
    }

    <app-campaign-team [form]="form" />
    <app-campaign-notes [form]="form" />
  }
</div>
